var exports = {
  "p_": "list__5TYFws",
  "Nr": "card__em6gzM",
  "wx": "header__FwPBUn",
  "zD": "titleLink__d549Un",
  "gr": "titleIcon__WMufd5",
  "oV": "closedBadge__DiYqlz",
  "jf": "statusRow__-yzCyF",
  "RJ": "statusRowLine__b_h0y4",
  "qS": "statusText__HLsw_G",
  "rI": "statusButton__OCUuPB",
  "aA": "mutationError__itUP3T",
  "SQ": "fieldsToggle__xEeWWY",
  "zz": "fieldsToggleInline__KtmAQA",
  "cx": "fieldsList__sl3KNg",
  "h0": "fieldRow__OZZ5Fp",
  "bk": "fieldLabel___H_JoH",
  "H4": "fieldValueText__jQH2Oz",
  "a0": "fieldValueButton__escRne",
};

module.exports = exports;
